import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import enTranslation from './locales/en/translation.json';
import viTranslation from './locales/vi/translation.json';
// Get language from localStorage if available, otherwise default to 'en'
const getInitialLanguage = () => {
    if (typeof window !== 'undefined') {
        return localStorage.getItem('language') || 'en';
    }
    return 'en';
};
const initializeI18n = () => {
    if (!i18n.isInitialized) {
        i18n
            .use(initReactI18next)
            .init({
                resources: {
                    en: {
                        translation: enTranslation
                    },
                    vi: {
                        translation: viTranslation
                    }
                },
                lng: getInitialLanguage(),
                fallbackLng: getInitialLanguage(),
                interpolation: {
                    escapeValue: false
                }
            });
    }
    return i18n;
};
export default initializeI18n();